import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';

import { FuseSharedModule } from './../../../../@fuse/shared.module';

import { FooterComponent } from './footer.component';
import { FuseFooterComponentDynamic } from './footer-dynamic/footer-dynamic.component';

@NgModule({
    declarations: [FooterComponent, FuseFooterComponentDynamic],
    imports: [RouterModule, MatButtonModule, MatIconModule, MatToolbarModule, FuseSharedModule],
    exports: [FooterComponent, FuseFooterComponentDynamic]
})
export class FooterModule {}
